import Cookies from "universal-cookie"

const cookies = new Cookies()
const COOKIE_NAME = "CookieConsentSettings"

export interface CookieConsent {
  necessary: boolean
  analytics_storage: boolean
  ad_storage: boolean
  functionality_storage: boolean
  personalization_storage: boolean
  security_storage: boolean
}

export const ALL_ACCEPTED: CookieConsent = {
  necessary: true,
  analytics_storage: true,
  ad_storage: true,
  functionality_storage: true,
  personalization_storage: true,
  security_storage: true,
}

export const NONE_ACCEPTED: CookieConsent = {
  necessary: true,
  analytics_storage: false,
  ad_storage: false,
  functionality_storage: false,
  personalization_storage: false,
  security_storage: false,
}

export const DEFAULT_SETTINGS = NONE_ACCEPTED

export const getConsent = (): CookieConsent => {
  return cookies.get(COOKIE_NAME)
}

export const saveConsent = (consent: CookieConsent): void => {
  cookies.set(COOKIE_NAME, consent, {
    path: "/",
    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
  })
}
